module.exports = __webpack_public_path__ + "static/media/Historia.2c699a1d.png";